module.exports = __webpack_public_path__ + "media/3-san.d94846e2.mp3";